import {
	MdAccessTime,
	MdAccountTree,
	MdBalance,
	MdBlock,
	MdBuildCircle,
	MdCalendarMonth,
	MdCancel,
	MdCheckCircle,
	MdCloudDone,
	MdDone,
	MdEditDocument,
	MdFactory,
	MdFastForward,
	MdHandyman,
	MdInventory,
	MdLocalShipping,
	MdLockOpen,
	MdMoveToInbox,
	MdOutlineLocalShipping,
	MdPending,
	MdPendingActions,
	MdRequestQuote,
	MdWarning,
	MdUnarchive,
	MdOutlineAttachMoney,
} from 'react-icons/md'

export const ORDER_STATUS_ICONS = {
	MdAccessTime: {
		icon: MdAccessTime,
		color: '#525252',
	},
	MdAccountTree: {
		icon: MdAccountTree,
		color: '#525252',
	},
	MdBalance: {
		icon: MdBalance,
		color: '#525252',
	},
	MdBuildCircle: {
		icon: MdBuildCircle,
		color: '#525252',
	},
	MdCalendarMonth: {
		icon: MdCalendarMonth,
		color: '#525252',
	},
	MdDone: {
		icon: MdDone,
		color: '#525252',
	},
	MdFastForward: {
		icon: MdFastForward,
		color: '#525252',
	},
	MdHandyman: {
		icon: MdHandyman,
		color: '#525252',
	},
	MdInventory: {
		icon: MdInventory,
		color: '#525252',
	},
	MdLockOpen: {
		icon: MdLockOpen,
		color: '#525252',
	},
	MdMoveToInbox: {
		icon: MdMoveToInbox,
		color: '#525252',
	},
	MdOutlineLocalShipping: {
		icon: MdOutlineLocalShipping,
		color: '#525252',
	},
	MdPending: {
		icon: MdWarning,
		color: '#FF0000',
	},
	MdPendingActions: {
		icon: MdPendingActions,
		color: '#525252',
	},
	MdUnarchive: {
		icon: MdUnarchive,
		color: '#525252',
	},
	MdEditDocument: {
		icon: MdEditDocument,
		color: '#292928',
	},
	MdCloudDone: {
		icon: MdCloudDone,
		color: '#027fe9',
	},
	MdFactory: {
		icon: MdFactory,
		color: '#b52c00',
	},
	MdCheckCirclePartially: {
		icon: MdCheckCircle,
		color: '#FFC000',
	},
	MdCheckCircle: {
		icon: MdCheckCircle,
		color: '#2EDD36',
	},
	MdBlock: {
		icon: MdBlock,
		color: '#FF3300',
	},
	MdCancel: {
		icon: MdCancel,
		color: '#FF3737',
	},
	MdLocalShipping: {
		icon: MdLocalShipping,
		color: '#525252',
	},
	MdRequestQuote: {
		icon: MdOutlineAttachMoney,
		color: '#2EDD36',
	},
}
